module.exports = __webpack_public_path__ + "img/star.739940de.svg";